import { ReactNode } from 'react';
import { NavBar } from '@/components/navbars/simple-navbar';
import { Footer } from '@/components/footer';
import { useCategoryTree } from '@socialflows/shared-lib';

export function StoreLayout({ children }: { children: ReactNode }) {
  const { data: categories = [] } = useCategoryTree();

  return (
    <div className="flex min-h-screen flex-col">
      <NavBar categories={categories} />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
